import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { SnackbarProvider } from './view/components/SnackbarService';
import AppRouter from './routing/AppRouter';
import './App.scss';
import { AuthProvider } from './auth/AuthContext';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#10B981', // Emerald Green for brand consistency
    },
    secondary: {
      main: '#3B82F6', // Blue for secondary actions
    },
    error: {
      main: '#EF4444', 
    },
    success: {
      main: '#10B981',
    },
    warning: {
      main: '#F59E0B',
    },
    background: {
      default: '#0A0A0A',
      paper: '#121212',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#9CA3AF',
      disabled: '#4B5563',
    },
  },
  typography: {
    fontFamily: 'Century Gothic, Poppins, Arial, sans-serif', // Combining your custom fonts
    fontSize: 14,
    button: {
      textTransform: 'none',
    },
    h1: {
      fontSize: '2.375rem', // Matches $h1-font-size
    },
    h2: {
      fontSize: '2rem', // Matches $h2-font-size
    },
    h3: {
      fontSize: '1.75rem', // Matches $h3-font-size
    },
    h4: {
      fontSize: '1.5rem', // Matches $h4-font-size
    },
    h5: {
      fontSize: '1.25rem', // Matches $h5-font-size
    },
    h6: {
      fontSize: '1rem', // Matches $h6-font-size
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: '12px',
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#111111',
          backgroundImage: 'none', // Remove the default MUI overlay on dark paper
          border: '1px solid #222222',
          borderRadius: '16px',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
  },
});

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <SnackbarProvider>
          <CssBaseline />
          <AppRouter />
        </SnackbarProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
